<div class="header-title">
  <div class="flex u-align-items-center u-pa-20">
    <div class="flex flex-align-center">
      <a routerLink="/button" aria-label="back"
        class="u-button u-button--link u-button--back u-button-icon-left u-ma-0 u-button--auto" type="button">
        <span class="u-icon icon-chevron-left"></span>
        <span class="u-button-text">Back</span>
      </a>
    </div>
    <div class="page-title flex u-w-100 u-justify-content-center u-position-absolute u-position-left">
      <h1 class="font-semibold u-ma-0 flex header-title--name">Toggle</h1>
    </div>
  </div>
  <div class="c-header__gradient"></div>
</div>
<div class="content">

  <h2>Template driven :: toggle</h2>

  <form>
    <maced-toggle name="toggle1" id="toggle1"
      [ariaLabel]="toggleNgModel ? 'toggle button switch on' : 'toggle button switch off'" [(ngModel)]="toggleNgModel">
    </maced-toggle>
  </form>

  <div>
    <h2>Result</h2>
    <div>
      Toggle value:-&nbsp;
      {{ toggleNgModel }}
    </div>
  </div>

  <br><br>

  <h2>Reactive form :: toggle</h2>

  <form [formGroup]="form">
    <maced-toggle id="palanca" name="palanca" ariaLabel="palanca" formControlName="toggle" texOn="sobre"
      textOff="apagado">
    </maced-toggle>
    <div *ngIf="form.controls.toggle.touched && form.controls.toggle.invalid">
      <div *ngIf="form.controls.toggle.errors?.required">
        Se requiere valor
      </div>
    </div>
    <br>
  </form>

  <div>
    <h2>Result</h2>
    <div>
      Toggle value:-&nbsp;
      {{ form.value | json }}
    </div>
  </div>

  <br><br>

  <h2>No JS :: toggle</h2>

  <form action="/toggle" method="get">
    <maced-toggle id="toggle3" name="toggle3" ariaLabel="टॉगल" [checked]="toggleValue === 'on'" onText="पर"
      offText="बंद">
    </maced-toggle>
    <maced-button buttonId="submit3" label="Submit" buttonType="submit"></maced-button>
  </form>

  <div>
    <h2>Result</h2>
    <div>
      Toggle value:-&nbsp;
      {{ toggleValue }}
    </div>
  </div>

  <br><br>

  <h2>Disabled :: toggle</h2>
  <maced-toggle id="toggle4" name="toggle4" [attr.aria-disabled]="true" ariaLabel="toggle" [disabled]="true">
  </maced-toggle>
  
  <h2>Toggle with icons with label display on both sides</h2>
  
  <div #tooltipTargetReference class="u-display-inline-block u-ml-80" title="">
    <maced-toggle name="toggle5" id="toggle5" [hasToggleIcon]="true" [displayIconLabel]="true" id="toggleId"
      [ariaLabel]="toggleNgModel1 === toggleMode2 ? 'Switch to bookviewer' : 'Switch to reading view'"
      [(ngModel)]="toggleNgModel1" [toggle1Text]="view1" [toggle2Text]="view2" [roleDescription]="role">
    </maced-toggle>
  </div>
  <maced-tooltip id="tooltip1" [hasCloseButton]="false" [hasCaret]="true" [placement]="selectedPlacement"
    [tooltipTargetReference]="tooltipTargetReference"
    [message]="toggleNgModel1 === toggleMode2 ? 'Switch to bookviewer' : 'Switch to reading view'">
  </maced-tooltip>
  <div>
    <h2>Result</h2>
    <div>
      Toggle value:-&nbsp;
      {{ toggleNgModel1 }}
    </div>
  </div>
  
  <h2>Toggle with icons with no labels</h2>
  
  <div #tooltipTargetReference1 class="u-display-inline-block u-ml-80" title="">
    <maced-toggle name="toggle6" id="toggle6" [hasToggleIcon]="true" [displayIconLabel]="false" id="toggleId1"
      [ariaLabel]="toggleNgModel2 === toggleMode2 ? 'Switch to bookviewer' : 'Switch to reading view'"
       [(ngModel)]="toggleNgModel2" [toggle1Text]="view1" [toggle2Text]="view2" [roleDescription]="role">
    </maced-toggle>
  </div>
  <maced-tooltip id="tooltip" [hasCloseButton]="false" [hasCaret]="true" [placement]="selectedPlacement"
    [tooltipTargetReference]="tooltipTargetReference1"
    [message]="toggleNgModel2 === toggleMode2 ? 'Switch to bookviewer' : 'Switch to reading view'">
  </maced-tooltip>
  <div>
    <h2>Result</h2>
    <div>
      Toggle value:-&nbsp;
      {{ toggleNgModel2 }}
    </div>
  </div>

  <h2>Toggle with icons with label on right side</h2>
  
  <div #tooltipTargetReference2 class="u-display-inline-block u-ml-80" title="">
    <maced-toggle name="toggle7" id="toggle7" [hasToggleIcon]="true" [displayIconLabel]="true" [displayLabelIconRight]="true"
      [ariaLabel]="toggleNgModel3 === toggleMode2 ? 'Switch to bookviewer' : 'Switch to reading view'" 
      [(ngModel)]="toggleNgModel3" [toggle1Text]="view1" [toggle2Text]="view2" id="toggleId2" [roleDescription]="role">
    </maced-toggle>
  </div>
  <maced-tooltip id="tooltip3" [hasCloseButton]="false" [hasCaret]="true" [placement]="selectedPlacement"
    [tooltipTargetReference]="tooltipTargetReference2"
    [message]="toggleNgModel3 === toggleMode2 ? 'Switch to bookviewer' : 'Switch to reading view'">
  </maced-tooltip>
  <div>
    <h2>Result</h2>
    <div>
      Toggle value:-&nbsp;
      {{ toggleNgModel3 }}
    </div>
  </div>

  <h2>Toggle with icons with no labels no js mode</h2>

  <form action="/toggle" method="get">
  <div class="u-display-inline-block u-ml-80" title="">
    <maced-toggle name="toggle9" id="toggle9" [hasToggleIcon]="true" [displayIconLabel]="false"
      [ariaLabel]="toggleNgModel5 === toggleMode2 ? 'Switch to bookviewer' : 'Switch to reading view'" 
      [checked]="toggleNgModel5 === 'on'"  id="toggleId4" [roleDescription]="role">
    </maced-toggle>
  </div>
  <div>
    <maced-button buttonId="submit3" label="Submit" buttonType="submit"></maced-button>
  </div>
  </form>
  <div>
    <h2>Result</h2>
    <div>
      Toggle value:-&nbsp;
      {{ toggleNgModel5 }}
    </div>
  </div>

   <h2>Toggle disabled mode</h2>
    <div #tooltipTargetReference2 class="u-display-inline-block u-ml-80" title="" >
    <maced-toggle name="toggle10" id="toggle10" [hasToggleIcon]="true" [displayIconLabel]="true" [displayLabelIconRight]="true"
      [ariaLabel]="toggleNgModel6 === toggleMode2 ? 'Switch to bookviewer' : 'Switch to reading view'" 
      [(ngModel)]="toggleNgModel6" [disabled]="true" [toggle1Text]="view1" [toggle2Text]="view2" id="toggleId2" [roleDescription]="role">
    </maced-toggle>
  </div>
  <maced-tooltip id="tooltip3" [hasCloseButton]="false" [hasCaret]="true" [placement]="selectedPlacement"
    [tooltipTargetReference]="tooltipTargetReference2"
    [message]="toggleNgModel6 === toggleMode2 ? 'Switch to bookviewer' : 'Switch to reading view'">
  </maced-tooltip>
  <div>
    <h2>Result</h2>
    <div>
      Toggle value:-&nbsp;
      {{ toggleNgModel6 }}
    </div>
  </div>

    <h2>Toggle button</h2>

  <form>
    <maced-toggle name="toggle11" id="toggle11" [isToggleButton]="true"
      [ariaLabel]="toggleNgModel ? 'toggle button switch on' : 'toggle button switch off'" [(ngModel)]="toggleNgModel">
    </maced-toggle>
  </form>

  <div>
    <h2>Result</h2>
    <div>
      Toggle value:-&nbsp;
      {{ toggleNgModel }}
    </div>
  </div>

</div>